import TextInput from 'components/ReusableComponents/ManageHotel/TextInput'
import Toggle from 'components/ReusableComponents/Toggle'
import { useEffect } from 'react'

import styles from '../../NewHotel.module.scss'

const ExtraServices = ({ formData, handleFormChange, setFormData }) => {
  useEffect(() => {
    if (!formData.hasSetupFee) {
      setFormData({ setupFee: '' })
    }
    if (!formData.hasPremiumSupport) {
      setFormData({ premiumSupportFee: '' })
    }
  }, [formData.hasSetupFee, formData.hasPremiumSupport, setFormData])

  const handleSetupToggle = () => {
    setFormData({ hasSetupFee: !formData.hasSetupFee })
  }
  const handlePremiumToggle = () => {
    setFormData({ hasPremiumSupport: !formData.hasPremiumSupport })
  }
  return (
    <div className={styles.extraServices}>
      <h4 className={styles.sectionTitle}>Extra Services</h4>
      <div className={styles.formToggleRow}>
        <Toggle
          label="Get setup fee"
          name="hasSetupFee"
          handleChange={handleSetupToggle}
          checked={formData.hasSetupFee}
        />

        <Toggle
          label="Enable premium support"
          name="hasPremiumSupport"
          handleChange={handlePremiumToggle}
          checked={formData.hasPremiumSupport}
        />
      </div>

      <div className={styles.formRow}>
        <TextInput
          type="text"
          label="One-time setup fee"
          name="setupFee"
          value={formData.setupFee}
          onChange={handleFormChange}
          disabled={!formData.hasSetupFee}
        />
        <TextInput
          type="text"
          label="Monthly premium support fee"
          name="premiumSupportFee"
          value={formData.premiumSupportFee}
          onChange={handleFormChange}
          disabled={!formData.hasPremiumSupport}
        />
      </div>
    </div>
  )
}

export default ExtraServices
